export const defaultLoaders = [
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    }
]

export const defaultHeaders = [
    {
        name: 'origem',
        text: 'Origem',
        position: 0
    },
    {
        name: 'tipoOperacao',
        text: 'Serviço',
        position: 1
    },
    {
        name: 'nomeAgente',
        text: 'Agente Financeiro',
        position: 2
    },
    {
        name: 'chassi',
        text: 'Chassi',
        position: 3
    },
    {
        name: 'renavam',
        text: 'Renavam',
        position: 4
    },
    {
        name: 'placa',
        text: 'Placa',
        position: 5
    },
    {
        name: 'status',
        text: 'Status',
        position: 6
    },
    {
        name: 'dataContrato',
        text: 'Data Contrato ',
        position: 7
    },
    {
        name: 'dataRegistro',
        text: 'Data Registro ',
        position: 7
    },
    {
        name: 'ufDetran',
        text: 'UF Detran',
        position: 8
    },
    {
        name: 'numeroContrato',
        text: 'N° Contrato',
        position: 10
    },
    {
        name: 'valorContrato',
        text: 'Valor Contrato',
        position: 11
    },
    {
        name: 'possuiImagem',
        text: 'Imagem',
        position: 12
    }
]
